import {IUserProfile} from "../types/IUserProfile";

export const checkHasPhone = (userProfile: IUserProfile | null | undefined): boolean => {
    return Boolean(userProfile?.phone);
};
import {IUserProfile} from "../types/IUserProfile";

export const checkHasPhone = (userProfile: IUserProfile | null | undefined): boolean => {
    return Boolean(userProfile?.phone);
};
